// Canonical music taxonomy (must mirror backend models.py MAIN_GENRES).
// Frontend keeps its own copy so upload forms render instantly without a roundtrip.

export const MAIN_GENRES = [
  "Hip-Hop / Rap", "R&B / Soul", "Alternative", "Electronic", "Rock", "Jazz",
  "Reggae", "Afrobeats", "Latin", "Country", "Classical", "Instrumental",
  "Spoken Word", "Teaching", "Worship", "Experimental",
  "Soundtrack / Cinematic", "Children & Family", "Other",
];

export const STYLE_TAG_SUGGESTIONS = [
  "Boom Bap", "Trap", "Lo-fi", "Neo Soul", "West Coast", "Memphis", "Drill",
  "Jazz Rap", "Ambient", "Choir", "Acoustic", "Dark", "432Hz", "Meditation",
  "Study", "Houston Chopped", "Live Band", "Synthwave", "Alternative R&B",
];

export const MOOD_TAG_SUGGESTIONS = [
  "Peaceful", "Aggressive", "Hopeful", "Dark", "Meditative", "Triumphant",
  "Reflective", "Energetic", "Melancholy", "Warm", "Cinematic", "Prayerful",
  "Study",
];
